import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi } from '@/hooks';
import { sidebarItems } from './sidebar';
import { queryParams } from './queryParams';
import type { StrapiBaseRequest, VisitaVirtualPage } from '@/interfaces/strapi';
import { getVisitaVirtual } from '@/services/strapi';
import { Gallery } from '@/components';

export const VisitaVirtual = (): ReactElement => {
	const {
		loading: loadingPage,
		data: page,
		error: errorPage,
	} = useStrapiApi<VisitaVirtualPage, StrapiBaseRequest>(getVisitaVirtual, {
		autoFetch: true,
		params: queryParams,
	});

	console.log('Visita virtual component: ', page);

	// Breadcrumb coherente con tus routes
	usePageBreadcrumb([{ label: 'El Colegio' }, { label: 'Visita Virtual' }]);

	// Sidebar estable (memoizado)
	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	if (loadingPage) return <div className="u-mt-md">Cargando…</div>;
	if (errorPage) return <div className="u-mt-md">No se pudo cargar la página.</div>;
	if (!page) return <div className="u-mt-md">No se encontró la página.</div>;

	return (
		<div className="c-cnm-gallery__list">
			<Gallery
				title="Exterior del colegio notarial"
				items={page.exterior.images}
				itemHeight="310px"
				overflow="hidden"
				columns={{ 350: 1, 768: 2, 1024: 2, 1536: 3 }}
				gap={32}
			/>

			<Gallery
				title="Acceso Juan de Mena"
				items={page.acceso.images}
				columns={{ 350: 1, 768: 2, 1024: 2, 1536: 2 }}
				gap={32}
			/>
			<Gallery
				title="Interior primera planta"
				items={page.interior1.images}
				columns={{ 350: 1, 768: 2, 1024: 3, 1536: 3 }}
				gap={32}
			/>

			<Gallery
				title="Interior segunda planta"
				items={page.interior2.images}
				pattern={[3, 2, 3]}
				itemHeight={310}
				gap={32}
				rowGap={32}
			/>

			{page.dossier?.url && (
				<div style={{ paddingTop: 16 }}>
					<a
						className="inline-flex items-center gap-2 rounded-md border px-4 py-2 text-sm hover:bg-muted"
						href={page.dossier.url}
						target="_blank"
						rel="noopener noreferrer"
						aria-label={`Abrir dossier ${page.dossier.name}`}
					>
						📄 Descargar dossier
					</a>
				</div>
			)}
		</div>
	);
};
